import React from 'react'
import arkaine from '../img/clients/arkaine.svg'
import axelar from '../img/clients/axelar.svg'
import base from '../img/clients/base.svg'
import binance from '../img/clients/binance_chain.svg'
import demether from '../img/clients/demether.svg'
import ethereum from '../img/clients/ethereum.svg'
import kadena from '../img/clients/kadena.svg'
import lystenlabs from '../img/clients/lystenlabs.svg'
import phantom from '../img/clients/phantom.svg'
import pulsechain from '../img/clients/pulsechain.svg'
import sonic from '../img/clients/sonic.svg'
import sui from '../img/clients/sui.svg'

const partnerLogos = [
  { id: 5,  name: 'lystenlabs', src: lystenlabs },
  { id: 3,  name: 'base', src: base },
  { id: 8,  name: 'sonic', src: sonic },
  { id: 4,  name: 'ethereum', src: ethereum },
  { id: 7,  name: 'pulsechain', src: pulsechain },
  { id: 2,  name: 'axelar', src: axelar },
  { id: 1,  name: 'arkaine', src: arkaine },
  { id: 6,  name: 'phantom', src: phantom },
  { id: 9,  name: 'sui', src: sui },
  { id: 10, name: 'binance', src: binance },
  { id: 11, name: 'kadena', src: kadena },
  { id: 12, name: 'demether', src: demether },
];

export default function Clients() {
  return (
    <div className='clients-carousel'>
      <div className='clients-carousel-list'>
        {partnerLogos.map((logo) => (
          <img
            className = 'clients-carousel-item'
            key={logo.id}
            src={logo.src}
            alt={logo.name} />
        ))}
      </div>
      <div aria-hidden className='clients-carousel-list'>
        {partnerLogos.map((logo) => (
          <img
            className = 'clients-carousel-item'
            key={logo.id}
            src={logo.src}
            alt={logo.name} />
        ))}
      </div>
    </div>
  )
}
